module.exports = __webpack_public_path__ + "static/media/license-passport-upload.229855b5.svg";